export class Article {

    articleRef: string;
    barcode: string;
    description: string;
    name: string;
    items:  number;
    threshold: number;
    ovpitems: number;
    tariffNumber: string;
    weight: number;
    length: number; 
    depth: number; 
    height: number;
    ovpWeight: number;
    ovpLength:  number;
    ovpDepth: number;
    ovpHeight: number;

    constructor(){}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/inventory/article-detail/article.ts